import { IExamRequestModel } from '../../models/requests/ExamRequestModel'
import { IExamModel } from '../../models/responses/ExamModel'
import { IExamDictionaryModel } from '../../models/responses/ExamDictionaryModel'
import { PagedResponseModel } from '../../models/responses/PagedResponseModel'
import { IPaginationFilter, generateQueryParams } from '../../models/requests/PaginationFilter'
import API from './Api'

class ExamApi {
  async GetExams(filter: IPaginationFilter) {
    return await API.get<PagedResponseModel<IExamModel[]>>(`ex/CompanyManager/Exams${generateQueryParams(filter)}`)
  }

  async GetExam(id: string) {
    return await API.get<IExamModel>('ex/CompanyManager/Exams/' + id)
  }
  
  async GetExamDictionary() {
    return await API.get<IExamDictionaryModel[]>(`ex/CompanyManager/Exams/dictionary`)
  }

  async AddExam(model: IExamRequestModel) {
    return await API.post('ex/CompanyManager/Exams', model)
  }

  async UpdateExam(model: IExamRequestModel) {
    return await API.put('ex/CompanyManager/Exams/' + model.id, model)
  }

  async DeleteExam(itemId: string) {
    return await API.delete<boolean>('ex/CompanyManager/Exams/' + itemId)
  }
}

export default new ExamApi()
